import { useRef } from 'react'
import {
    Box,
    Card as ThemeCard,
    Flex,
    Heading,
    Image,
    Text,
} from '@theme-ui/components';
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
    Circle,
    ImagePlaceholder,
    Skeleton
} from '~/Common'

export const FeaturedCompany = ({ company, hideCardLink, ...props }) => {
    const { t } = useTranslation();
    const nodeRef = useRef(null);

    return (
        <CSSTransition
            nodeRef={nodeRef}
            in={true}
            timeout={500}
            classNames="fade"
            unmountOnExit
            appear
        >
            <ThemeCard
                ref={nodeRef}
                variant="featured"
                as={Link}
                to={`/companies/${company?.slug}`}
            >
                <Box sx={{
                    position: 'relative',
                    width: ['100%'],
                    minHeight: ['40vw', '40vw', '40vw', '450px'],
                    maxHeight: ['450px', '450px', '450px', 'none']
                }}>
                    {company ? (
                        <>
                            {company?.banner?.sizes?.featured ? (
                                <Box sx={{
                                    width: '100%',
                                    height: '100%'
                                }}>
                                    <Image src={company?.banner?.sizes?.featured} sx={{
                                        objectFit: 'cover',
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        width: '100%',
                                        height: '100%'
                                    }} />
                                </Box>
                            ) : (
                                <ImagePlaceholder sx={{
                                    width: '100%',
                                    height: '100%'
                                }} />
                            )}
                        </>
                    ) : (
                        <Skeleton width="100%" height="100%" />
                    )}

                    <Circle size="70px" type="box" ml={'auto'} sx={{
                        bg: 'white',
                        position: 'absolute',
                        top: '88px',
                        right: '-24px',
                        zIndex: 50,
                        overflow: 'hidden',
                        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)'
                    }}>
                        {company ? (
                            <>
                            {company?.logo?.sizes?.tiny ? (
                                <Image src={company?.logo?.sizes?.tiny} sx={{ borderRadius: '50%' }} />
                            ) : (
                                <ImagePlaceholder sx={{
                                    width: '70px',
                                    height: '70px',
                                    borderRadius: '50%'
                                }} />
                            )}
                            </>
                        ) : (
                            <Skeleton variant="circle" size="70px" />
                        )}

                    </Circle>
                </Box>

                <Box px={[3,3,3,'48px']} py={4} sx={{
                    position: 'relative',
                    flexDirection: 'column',
                    flexGrow: 1,
                }}>
                    <Flex sx={{
                        flexDirection: 'row',
                        flexWrap: 'nowrap'
                    }}>
                        <Box mb={3} pr={2} sx={{ width: '100%' }}>
                            {company ? <Text as="p" color="dark" mb={2}>{company?.category?.name}</Text> : <Skeleton height="14px" width="50px" mb={2} />}
                            {company ? <Heading as="h3" variant="h3" sx={{ fontSize: '30px' }}>{t(company?.name)}</Heading> : <Skeleton height="48px" width="70%" mb={2} />}
                        </Box>
                    </Flex>

                    {company ? (
                        <Box
                            mt={[1, 1, 1, 3]}
                            sx={{
                                minHeight: '110px',
                                pb: 3,
                                fontSize: '14px',
                                lineHeight: '1.4',
                                letterSpacing: '0.01em',
                                color: 'black',
                            }}
                        >
                            {company?.summary}
                        </Box>
                    ) : null}
                </Box>
            </ThemeCard>
        </CSSTransition>
    );
};
